import { render, staticRenderFns } from "./OfferThemeCoreRegister.vue?vue&type=template&id=38ab2435"
import script from "./OfferThemeCoreRegister.vue?vue&type=script&lang=js"
export * from "./OfferThemeCoreRegister.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports